import React, { useRef, useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPublicSearchConfig,
  updateSearchFilters,
} from "../../../../../../../actions/search";
import config from "../../../../../../../config/customers";
import { Card, CardBody } from "./components/Card";
import TabForm from "./components/TabForm";
import TabLink from "./components/TabLink";
import TabNav from "./components/TabNav";

const {
  publicPortal: { mainSearchSection: MAIN_SEARCH_SECTION },
} = config;

const Links = ({ activeOption, onClick }) => {
  const onClickHandler = (value) => onClick(value);
  return (
    <TabNav>
      <TabLink
        active={activeOption === "forSale"}
        onClick={() => onClickHandler("forSale")}
      >
        Buy
      </TabLink>
      <TabLink
        active={activeOption === "forRent"}
        onClick={() => onClickHandler("forRent")}
      >
        Rent
      </TabLink>
    </TabNav>
  );
};

const SearchCard = () => {
  const dispatch = useDispatch();
  const searchConfig = useSelector((state) => state.search.searchConfig);
  const filters = useSelector((state) => state.search.filters);
  const criteria = filters.Criteria;
  const initialCriteria = useRef(criteria);
  const [searchType, setSearchType] = useState(
    filters?.Criteria?.forSale ? "forSale" : "forRent"
  );

  const isSearchConfigLoaded = Boolean(Object.keys(searchConfig ?? {}).length);

  const changeSearchType = (type) => {
    setSearchType(type);
    let newCriteria = criteria;

    if (type === "forSale") {
      const {
        minRent: _minRent,
        maxRent: _maxRent,
        ...restCriteria
      } = criteria;
      newCriteria = { ...restCriteria, forSale: true, forRent: false };
    } else {
      const {
        minForSale: _minForSale,
        maxForSale: _maxForSale,
        ...restCriteria
      } = criteria;
      newCriteria = { ...restCriteria, forSale: false, forRent: true };
    }
    dispatch(updateSearchFilters({ ...filters, Criteria: newCriteria }));
  };

  useEffect(() => {
    if (!searchConfig?.PropertyType) return;
    /**
     * Initialize search criteria with default property types
     */
    dispatch(
      updateSearchFilters({
        Criteria: {
          ...initialCriteria?.current,
          propertyType: searchConfig.PropertyType.DefaultOptions,
        },
      })
    );
  }, [dispatch, searchConfig?.PropertyType]);

  useEffect(() => {
    if (!isSearchConfigLoaded) dispatch(fetchPublicSearchConfig());
  }, [dispatch, isSearchConfigLoaded]);

  return (
    <Card>
      <CardBody>
        <Links activeOption={searchType} onClick={changeSearchType} />
        <TabForm
          searchConfig={searchConfig}
          sectionDetails={MAIN_SEARCH_SECTION}
          searchType={searchType}
        />
      </CardBody>
    </Card>
  );
};

export default SearchCard;
